import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/about/tiktok_logo.png')
const LOGO = assets.images.about.tiktokLogo

const TiktokLogo = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default TiktokLogo
